import React, {Component} from 'react';
import Logger from "../helpers/Logger";
import Preloader from "./Preloader";

export default class PreloaderContainer extends Component {
    componentDidCatch(error, info) {
        const logger = new Logger(this.props.logPath);
        logger.critical('REACT: error caught in PreloaderContainer', error.toString());
    }

    render() {
        return (<Preloader dataParameters={this.props.parameters} />);
    }
}



// WEBPACK FOOTER //
// ./src/components/PreloaderContainer.js